"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scoreLog = exports.isRuleComplete = exports.indexRuleLogsById = exports.getRulesByCadence = exports.getMandatoryRules = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
// Challenges engine (#1519) — shared, framework-free rule-mechanic evaluation.
//
// A "rule" is a provider-authored instance of a fixed input-mechanic vocabulary
// (challenges.rules[].inputType): CHECKBOX | NUMBER | COUNTER | TIMER |
// DURATION_TARGET | ACTIVITY_LOG | PHOTO | MEASUREMENTS | NOTE. Providers configure
// everything ABOUT a rule (title, description, mandatory/optional, cadence,
// thresholds, score weight) — they don't author new mechanics; this file is the
// exhaustive list of what each mechanic means.
//
// Mirrored (by hand, in sync) in TS at api/training/src/core/challengeEngine.ts,
// which additionally owns the completion/elimination POLICY orchestration — that
// Lambda package doesn't bundle @guryou/utils, so the mechanic-level check is
// duplicated rather than shared at runtime. Used from deal (challenge builder
// preview) and feel (daily checklist rendering) for live client-side feedback; the
// server is authoritative for streak/score writes.
//
// Only COUNTER/TIMER/DURATION_TARGET/ACTIVITY_LOG carry a numeric completion
// threshold; every other inputType falls back to `ruleLog.completed === true`.

var isRuleComplete = exports.isRuleComplete = function isRuleComplete(rule, ruleLog) {
  var _config$target, _ruleLog$fasting$dura, _ruleLog$fasting, _config$windowHours;
  if (!ruleLog) {
    return false;
  }
  var config = rule.config || {};
  switch (rule.inputType) {
    case 'COUNTER':
    case 'TIMER':
      return typeof ruleLog.value === 'number' && ruleLog.value >= ((_config$target = config.target) !== null && _config$target !== void 0 ? _config$target : Infinity);
    case 'DURATION_TARGET':
      return ((_ruleLog$fasting$dura = (_ruleLog$fasting = ruleLog.fasting) === null || _ruleLog$fasting === void 0 ? void 0 : _ruleLog$fasting.durationMinutes) !== null && _ruleLog$fasting$dura !== void 0 ? _ruleLog$fasting$dura : 0) >= ((_config$windowHours = config.windowHours) !== null && _config$windowHours !== void 0 ? _config$windowHours : Infinity) * 60;
    case 'ACTIVITY_LOG':
      {
        var _config$minTotalMinut, _config$minSingleSess;
        var activities = ruleLog.workoutActivities || [];
        var totalMinutes = activities.reduce(function (sum, a) {
          return sum + toMinutes(a.duration);
        }, 0);
        var maxSingleMinutes = activities.reduce(function (max, a) {
          return Math.max(max, toMinutes(a.duration));
        }, 0);
        return totalMinutes >= ((_config$minTotalMinut = config.minTotalMinutes) !== null && _config$minTotalMinut !== void 0 ? _config$minTotalMinut : Infinity) && maxSingleMinutes >= ((_config$minSingleSess = config.minSingleSessionMinutes) !== null && _config$minSingleSess !== void 0 ? _config$minSingleSess : Infinity);
      }
    default:
      return ruleLog.completed === true;
  }
};
var toMinutes = function toMinutes(duration) {
  if (typeof duration === 'number') {
    return duration;
  }
  var _String$split$map = String(duration || '0:0').split(':').map(Number),
    _String$split$map2 = (0, _slicedToArray2["default"])(_String$split$map, 2),
    h = _String$split$map2[0],
    m = _String$split$map2[1];
  return (h || 0) * 60 + (m || 0);
};
var getMandatoryRules = exports.getMandatoryRules = function getMandatoryRules(rules) {
  return (rules || []).filter(function (rule) {
    return rule.mandatory;
  });
};
var getRulesByCadence = exports.getRulesByCadence = function getRulesByCadence(rules, cadence) {
  return (rules || []).filter(function (rule) {
    return rule.cadence === cadence;
  });
};

// challenge_daily_logs.rule_logs is stored as an ARRAY of {ruleId, ...status} (never
// an id-keyed object — the @the-neon/pg castRow convention); this indexes it by
// ruleId for in-process lookups only, at the read boundary.
var indexRuleLogsById = exports.indexRuleLogsById = function indexRuleLogsById(log) {
  var entries = (log === null || log === void 0 ? void 0 : log.ruleLogs) || (log === null || log === void 0 ? void 0 : log.rule_logs) || [];
  return entries.reduce(function (map, entry) {
    map[entry.ruleId] = entry;
    return map;
  }, {});
};

// Score a single log against every rule that applies to it (used for live preview;
// the server recomputes totalScore authoritatively on write).
var scoreLog = exports.scoreLog = function scoreLog(rules, log) {
  var statuses = indexRuleLogsById(log);
  return (rules || []).reduce(function (sum, rule) {
    var _rule$scoreWeight;
    return sum + (isRuleComplete(rule, statuses[rule.ruleId]) ? (_rule$scoreWeight = rule.scoreWeight) !== null && _rule$scoreWeight !== void 0 ? _rule$scoreWeight : 1 : 0);
  }, 0);
};
